import { useEffect, useState } from "react";
import usePageNavigation from "../../uesPageNavigation"; // Corrected import path
import "../../assets/sass/shareStyle.scss";
import "../../assets/sass/paymentStyle.scss";
import "../../assets/sass/orderStyle.scss";
import { FaArrowLeft } from "react-icons/fa";
import "react-calendar/dist/Calendar.css";
import { loadStripe } from "@stripe/stripe-js";
import { Elements } from "@stripe/react-stripe-js";
import CryptoJS from "crypto-js";
import CheckoutFromStripe from "./CheckoutFromStripe";
import TabTitleChanger from "../TabTitleChanger";

export default function PaymentOrder() {
  const { navigateToPage, state } = usePageNavigation(); // Custom hook to navigate

  const [isOnTop, setIsOnTop] = useState(false);
  const [isAlert, setIsAlert] = useState(false);
  // eslint-disable-next-line no-unused-vars
  const [alertValue, setAlertValue] = useState("");
  const [paymentCount, setPaymentCount] = useState(0);

  const [isStripePromise, setIsStripePromise] = useState(null);

  useEffect(() => {
    setPaymentCount(state.paymentCount);
    fetchAndDecryptKey();
    window.scrollTo({
      top: 0, // Scroll to the top
      behavior: "smooth", // Smooth scrolling transition
    });
    // Check when the component mounts
    checkIfAtTop();

    // Optionally, you can listen to scroll events and check in real-time
    window.addEventListener("scroll", checkIfAtTop);

    // Cleanup listener on component unmount
    return () => window.removeEventListener("scroll", checkIfAtTop);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const decryptKey = (encryptedKey) => {
    const bytes = CryptoJS.AES.decrypt(
      encryptedKey,
      "egx8c9rbtz5q73klfdmn4w10hvoip6"
    );
    return bytes.toString(CryptoJS.enc.Utf8);
  };

  const fetchAndDecryptKey = async () => {
    const response = await fetch(
      "https://ccglove-web-api.onrender.com/api/get-publish-key"
    );
    const data = await response.json();
    const stripePromise = loadStripe(decryptKey(data.encryptedKey));
    setIsStripePromise(stripePromise);
  };

  const checkIfAtTop = () => {
    if (window.scrollY === 0 || document.documentElement.scrollTop === 0) {
      setIsOnTop(true);
    } else {
      setIsOnTop(false);
    }
  };

  const handleRevertServicePrice = (grandTotal) => {
    const movingFee = state.userInfo.movingFee;

    const servicePrice =
      (grandTotal - 1.146 * movingFee) /
      1.146 /
      (1 - state.discountInfo.discountResult / 100);

    // Round and return the final value
    return Math.round(servicePrice);
  };

  const handleNavigateBack = () => {
    navigateToPage("/summaryOrder", {
      moveFrom: state.moveFrom,
      orderType: state.orderType,
      paymentCount: handleRevertServicePrice(paymentCount),
      discountInfo: state.discountInfo,
      workingTime: state.workingTime,
      userInfo: {
        firstName: state.userInfo.firstName,
        lastName: state.userInfo.lastName,
        phone: state.userInfo.phone,
        email: state.userInfo.email,
        prefecture: state.userInfo.prefecture,
        district: state.userInfo.district,
        town: state.userInfo.town,
        postCode: state.userInfo.postCode,
        addDetail: state.userInfo.addDetail,
        movingFee: state.userInfo.movingFee,
      },
    });
  };
  const formatNumber = (number) => {
    return number.toLocaleString();
  };
  const getServiceType = (type) => {
    switch (type) {
      case 0:
        return "Hourly Service";
      case 1:
        return "Daily Service";
      case 2:
        return "Custom Service";
      default:
        return "";
    }
  };

  return (
    <Elements stripe={isStripePromise}>
      <TabTitleChanger title="Checkout" />
      <main className="content">
        <div className="payment__container">
          <div className={`page__headline ${isOnTop && `onTop`}`}>
            <div
              className="page__headline_icon_container"
              onClick={handleNavigateBack}
            >
              <FaArrowLeft className="page__headline_icon" />
            </div>
            <div className="page__headline_title">Check Out</div>
          </div>
          <div className="payment__content">
            <div className="payment__info">
              <div className="payment__info_content">
                <div className="payment__info_item">
                  <div className="payment__info_item_title">Service:</div>
                  <div className="payment__info_item_value">
                    {getServiceType(state.orderType)}
                  </div>
                </div>
                <div className="payment__info_item">
                  <div className="payment__info_item_title highlight">
                    Total:
                  </div>
                  <div className="payment__info_item_value highlight">
                    {formatNumber(Math.round(paymentCount))}¥
                  </div>
                </div>
              </div>
            </div>
            <div className="payment__atm">
              {state.clientSecret && (
                <CheckoutFromStripe
                  clientSecret={state.clientSecret}
                  stateValue={state}
                />
              )}
            </div>
          </div>
          {isAlert && (
            <div className="pop__container">
              <div className="pop__content">
                <div className="pop__alert">{alertValue}</div>
                <div className="pop__close" onClick={() => setIsAlert(false)}>
                  close
                </div>
              </div>
            </div>
          )}
        </div>
      </main>
    </Elements>
  );
}
